const VITALS = {
    children: [
        {
            value: 'blood-pressure',
            label: 'Blood Pressure'
        },
        {
            value: 'blood-glucose',
            label: 'Blood Sugar'
        },
        {
            value: 'temperature',
            label: 'Temperature'
        },
        {
            value: 'weight',
            label: 'Weight'
        },
        {
            value: 'heart-Rate',
            label: 'Heart Rate'
        },
        {
            value: 'Stress',
            label: 'Stress'
        },
        {
            value: 'mood',
            label: 'Mood'
        },
        {
            value: 'sleep',
            label: 'Sleep'

        }
    ]
}

import hasCount from './util/has-count'

export default {
    option: {
        value: 'vital',
        label: 'Vital',

        children: [
            {
                value: 'vital-includes',
                label: 'Has logged',
                select: VITALS,

                match: hasCount({ type: 'vital' })
            },
            {
                value: 'not-vital-includes',
                label: 'Has not logged',
                select: VITALS,

                match: hasCount({ type: 'vital', not: true })
            }
        ]
    }
}
